import { Button, Input, Loader, PasswordInput } from "@mantine/core";
import { IconAt, IconLock } from "@tabler/icons-react";
import { useCallback } from "react";
import { type SubmitHandler, useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { usePostApi } from "src/hooks";
import { type IRegisterForm } from "src/interfaces";
import { Notification } from "src/utils/Notification";

const RegisterForm = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { register, handleSubmit } = useForm<IRegisterForm>();
  const { post, isLoading } = usePostApi();

  const handleLogin = useCallback(() => {
      const code = searchParams.get("code");

    navigate("/auditor/login?code="+code);
  }, [navigate]);

  const onSubmit: SubmitHandler<IRegisterForm> = useCallback(
    async data => {
      const params = data;
      const code = searchParams.get("code");
      if (!code) {
        Notification(
          "Error",
          "Your code is invalid, make sure you use the link from our mail.",
          "red",
        );
        return;
      }
      params.code = code;
      await post({
        request: "auditor-create",
        body: { params },
        onSuccess: () => {
            const code = searchParams.get("code");
          navigate("/auditor/login?code="+code);
        },
      });
    },
    [navigate, post, searchParams],
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Input
        mt={10}
        placeholder="First Name"
        {...register("fname", { required: true })}
      />
      <Input
        mt={10}
        placeholder="Surname"
        {...register("sname", { required: true })}
      />
      <Input
        mt={10}
        placeholder="Role"
        {...register("role", { required: true })}
      />
      <Input
        mt={10}
        placeholder="Flag / Authority"
        {...register("flag", { required: true })}
      />
      <Input
        mt={10}
        placeholder="Email Address"
        leftSection={<IconAt size="1rem" />}
        {...register("email", { required: true })}
      />
      <PasswordInput
        mt={10}
        placeholder="Password"
        leftSection={<IconLock size="1rem" />}
        withAsterisk
        {...register("pass", { required: true })}
      />
      <Button w="100%" type="submit" mt={20}>
        {isLoading ? <Loader color="#fff" mah={"20px"} /> : "Register"}
      </Button>
      <Button w="100%" mt={10} variant="white" onClick={handleLogin}>
        Log in instead
      </Button>
    </form>
  );
};

export default RegisterForm;
